export default class ConversationQuickAnswerModel {
  id!: number;

  nome!: string;

  respostaPronta!: string;
}
